export const consoleColors = {
    misc: 'background: #16a596; color: white; display: block; padding: 5px; border-radius: 4px;',
    insights: 'background: #a471ec; color: white; display: block; padding: 5px; border-radius: 4px;',
    events: 'background: #595b83; color: white; display: block; padding: 5px; border-radius: 4px;'
}